import { css } from '@emotion/css';

export const topBar = css`
  overflow: visible;
`;
